export default {
  offeringAPI: {
    defaultValue: 'https://cts-api.kambi.com/offering/v2018'
  },
  playerAPI: {
    defaultValue: 'https://cts-auth-api.kambicdn.com/player/api/v2019'
  },
  skdScript: 'https://cts-static.kambi.com/client',
  pushAPI: 'wss://cts-push.kambi.com',
  widgetsAPI: {
    url: 'https://static.kambicdn.com/client/widget-api'
  }
};
